<!-- 广告弹窗 -->
<template>
    <div class="bottom-adv">
        <div class="content">
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item, index) in advConfig" :key="index">
                    <a :href="item.url">
                        <img :src="item.img | urlFilter" alt="">
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>
<script>
export default {
    name: 'topAdv',
    props: {
        advConfig: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            imgUrl: 'https://files.sciconf.cn/',
        }
    },
    methods: {
    },
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
        clearInterval(this.timer)
        this.timer = null
    }
}
</script>
<style lang="less" scoped>
/deep/.van-swipe {
    height: 100%;
}
// 移动端
.bottom-adv {
    width: 100%;
    position: relative;
    padding-bottom: 2.15rem;
    .content {
        width: 100%;
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        height: 100%;
        a {
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center center;
            }
        }
    }
}
</style>